import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { RootContext } from "@-/dev.improve.haniverse.routes._context";

/**
 * The preferred size of a grapheme drill's glyph (the glyph block renders only in grapheme drills,
 * so there is no word layout to size). It matches the new-character glyph's preferred size; the
 * glyph block measures and clamps it to the room its layout gives it, including when the answer
 * keyboard shortens the card.
 */
export function useDrillPageStrokeViewSize() {
  const [orientation, windowDimensions] = useContextSelectors(
    RootContext,
    (c) => c.orientation,
    (c) => c.windowDimensions,
  );
  const { height, width } = windowDimensions;

  return orientation === "landscape"
    ? Math.min(width / 2 - 80, height - 120, 360)
    : Math.min(width - 80, 280);
}
